<template>
  <div class="index3">
    <div class="logout" @click="logout">
      <img src="../assets/images/logout-icon.png" alt="">
      <img src="../assets/images/logout.png" alt="">
    </div>
    <c-header :bg-img="bgImg" @click.native="$router.push('/index3')"></c-header>
    <div class="index3-header-title">
      <c-title
        title="服务网络运营数据"
        title-en="SERVICE NETWORK OPERATION DATA"
        :width="1200"
      ></c-title>
    </div>
    <div class="index3-content">
      <div style="width: 100%;height: 100%;">
        <div class="index3-content-l" v-show="!currentIndex">
          <map-table :list="hqData"></map-table>
        </div>
        <div class="chart" id="chart" ref="chart"></div>
        <div class="index3-content-r" v-show="!currentIndex">
          <map-table
            title="奔腾"
            :is-hq="false"
            :list="btData"></map-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cHeader from '../components/c-header'
import cTitle from '../components/c-title'
import mapTable from '../components/map-table'
import { getMapData, postLogout } from '../api'
/* eslint-disable */
import mapFeatures from '../assets/json/china.json'
import {
  mapTipT,
  mapTipM,
  mapTipB,
  mapNum,
  cityIconSize,
  carIcon,
  batteryIcon,
  eqIcon,
  convenienceIcon,
  clientIcon,
  firstMap,
  mapStep,
  cache
} from '../config'

const mapName = 'china'
export default {
  name: 'index3',
  components: {
    cHeader,
    cTitle,
    mapTable
  },
  data() {
    return {
      currentIndex: -1,
      totalTimerList: [],
      totalTimerCount: 0,
      totalCount: -1,
      totalTimer: null,
      // nbd
      NBDList: [],
      // 便携设备
      convenienceList: [],
      // 客户
      clientList: [],
      cityIconSize: cityIconSize,
      geoCoordMap: {},
      hqData: [],
      btData: [],
      bgImg: require('../assets/images/header-title2.png'),
      option: {
        legend: {
          show: false
        },
        tooltip: {
          show: true
        },
        geo: {
          map: mapName,
          aspectScale: 0.75,
          label: {
            emphasis: {
              show: false
            }
          },
          tooltip: {
            show: true
          },
          regions: [
            {
              name: '南海诸岛',
              value: 0,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false
                  }
                }
              }
            }
          ],
          itemStyle: {
            normal: {
              shadowColor: '#1773c3',
              shadowBlur: 40,
              borderColor: '#084c92',
              borderWidth: 0.5,
              areaColor: {
                x: 1000,
                y: 1000,
                x2: 1000,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#04224b' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#04224b' // 50% 处的颜色
                  }
                ],
                global: true // 缺省为 false
              },
              opacity: 1
            },
            emphasis: {
              show: false,
              areaColor: '#69c5d8'
            },
            z: 2
          },
          series: []
        }
      }
    }
  },
  computed: {
    defaultSeries() {
      return [
        {
          type: 'map',
          map: mapName,
          label: {
            emphasis: {
              show: false,
              color: '#fff'
            }
          },
          tooltip: {
            show: false
          },
          top: '9%',
          aspectScale: .75,
          roam: false,
          itemStyle: {
            normal: {
              borderColor: '#00b3ff',
              borderWidth: 1.5,
              areaColor: {
                type: 'linear-gradient',
                x: 0,
                y: 1000,
                x2: 1000,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#1d88ea' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#1337aa' // 50% 处的颜色
                  }
                ],
                global: true // 缺省为 false
              }
            },
            emphasis: {
              show: false,
              areaColor: '#274d62'
            }
          },
          zlevel: 1
        },
        {
          name: '城市',
          type: 'scatter',
          coordinateSystem: 'geo',
          symbolSize: this.cityIconSize,
          symbol: carIcon,
          tooltip: {
            show: false
          },
          data: this.convertData(this.data),
          label: {
            normal: {
              formatter: '{b}',
              position: 'bottom',
              textStyle: {
                fontSize: 24,
                fontWeight: 'bolder',
                color: '#ffffff'
              },
              show: true
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            normal: {
              color: '#ddb926'
            }
          },
          zlevel: 2
        }
      ]
    }
  },
  watch: {
    totalCount(val) {
      const currentVal = val % this.totalTimerCount
      const currentIndex = this.isArrIndex(this.totalTimerList, currentVal)
      this.initChart(currentIndex)
    }
  },
  created() {
    this.getMapData()
  },
  destroyed() {
    clearInterval(this.timer)
    clearInterval(this.totalTimer)
  },
  methods: {
    // 退出登录
    logout() {
      const _this = this
      this.$confirm({
        title: '请确定',
        content: '是否退出登录?',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          postLogout().then(() => {
            _this.$router.replace('/login')
            localStorage.removeItem(cache.token)
          })
        }
      })
    },
    init() {
      this.registerMap()
      this.initChart(0)
      this.totalTimer = setInterval(() => {
        this.totalCount += 1
      }, 1000)
    },
    // 注册chart
    initChart(currentVal = -1) {
      if (currentVal === this.currentIndex) return
      this.currentIndex = currentVal
      this.setSeries(currentVal)
      if (this.chart) this.chart.clear()
      this.chart = this.$echarts.init(this.$refs.chart)
      this.chart && this.chart.setOption(this.option)
    },
    // 设置series
    setSeries() {
      if (this.currentIndex === 0) {
        this.cityIconSize = cityIconSize
        this.chart && this.chart.dispatchAction({
          type: 'hideTip'
        })
        this.setSeries1()
      } else if (this.currentIndex === 1) {
        this.cityIconSize = 0.0001
        this.setSeries2()
        this.autoTooltip()
      } else if (this.currentIndex === 2) {
        this.cityIconSize = 0.0001
        this.setSeries3()
        this.autoTooltip()
      } else if (this.currentIndex === 3) {
        this.cityIconSize = 0.0001
        this.setSeries4()
        this.autoTooltip()
      } else if (this.currentIndex === 4) {
        this.cityIconSize = 0.0001
        this.setSeries5()
        this.autoTooltip()
      }
    },
    autoTooltip() {
      let index = 0
      this.$nextTick(() => {
        this.chart && this.chart.dispatchAction({
          type: 'showTip',
          seriesIndex: 2,
          dataIndex: index
        })
        if (this.option.series[2].data.length > 1) {
          index++
          if (this.timer) clearInterval(this.timer)
          this.timer = setInterval(() => {
            this.chart && this.chart.dispatchAction({
              type: 'showTip',
              seriesIndex: 2,
              dataIndex: index
            })
            index++
            if (index >= this.option.series[2].data.length) {
              index = 0
            }
          }, mapStep * 1000)
        }
      })
    },
    // 处理数据5
    setSeries5() {
      this.option.series = [
        ...this.defaultSeries,
        ...[
          {
            name: '客户',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: clientIcon,
            symbolSize: [40, 50],
            symbolOffset: [0, -20],
            data: this.convertData(this.clientList),
            tooltip: {
              position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0] + 200, '15%']
              },
              formatter(params) {
                const paramsData = params.data
                const { name, value } = paramsData
                const data = value[2]
                const header = `<div>
                                  <div style="width: 499px;height: 65px;background:url('${mapTipT}') no-repeat;background-size: cover;">
                                     <p style="text-align: center;color: #65CCFF;font-size: 32px;padding-top: 8px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${name}</p>
                                  </div>
                                  <div style="width: 499px;background:url('${mapTipM}') repeat-y;">`
                const footer = `</div><div style="width: 499px;height: 56px;background:url('${mapTipB}') no-repeat;background-size: cover;"></div>
                                </div>`
                let content = ``
                data.forEach((item, index) => {
                  const { title, owner, location, url } = item
                  if (index) {
                    content += `<div style="padding: 20px 15px;">
                                    <p style="width: 100%;height: 3px;background:#00BBFF;"></p>
                                </div> `
                  }
                  content += `<p style="text-align: center;font-size: 36px;color: #65CCFF;padding:30px 20px 10px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${title}</p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height: 40px;">
                                持有人: ${owner}
                              </p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height: 40px;width: 440px;white-space: normal; ">
                                定位: ${location}
                              </p>
                              <div style="text-align: center;padding: 20px 60px 0;">
                                <img style="width: 100%;" src="${url}" alt="">
                              </div>
`
                })
                return header + content + footer
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          }
        ]
      ]
    },
    // 处理数据4
    setSeries4() {
      this.option.series = [
        ...this.defaultSeries,
        ...[
          {
            name: '便携检测设备',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: convenienceIcon,
            symbolSize: [40, 50],
            symbolOffset: [0, -20],
            data: this.convertData(this.convenienceList),
            tooltip: {
              position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0] + 200, '15%']
              },
              formatter(params) {
                const paramsData = params.data
                const { name, value } = paramsData
                const data = value[2]
                const header = `<div>
                                  <div style="width: 499px;height: 65px;background:url('${mapTipT}') no-repeat;background-size: cover;">
                                     <p style="text-align: center;color: #65CCFF;font-size: 32px;padding-top: 8px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${name}</p>
                                  </div>
                                  <div style="width: 499px;background:url('${mapTipM}') repeat-y;">`
                const footer = `</div><div style="width: 499px;height: 56px;background:url('${mapTipB}') no-repeat;background-size: cover;"></div>
                                </div>`
                let content = ``
                data.forEach((item, index) => {
                  const { title, owner, location, url } = item
                  if (index) {
                    content += `<div style="padding: 20px 15px;">
                                    <p style="width: 100%;height: 3px;background:#00BBFF;"></p>
                                </div> `
                  }
                  content += `<p style="text-align: center;font-size: 36px;color: #65CCFF;padding:30px 20px 10px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${title}</p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height: 40px;">
                                持有人: ${owner}
                              </p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height: 40px;width: 440px;white-space:normal;">
                                定位: ${location}
                              </p>
                              <div style="text-align: center;padding: 20px 60px 0;">
                                <img style="width: 100%;" src="${url}" alt="">
                              </div>
`
                })
                return header + content + footer
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          }
        ]
      ]
    },
    // 处理数据3
    setSeries3() {
      this.option.series = [
        ...this.defaultSeries,
        ...[
          {
            name: '电池',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: eqIcon,
            symbolSize: [40, 50],
            symbolOffset: [0, -20],
            data: this.convertData(this.PDAList),
            tooltip: {
              position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0] + 200, '15%']
              },
              formatter(params) {
                const paramsData = params.data
                const { name, value } = paramsData
                const data = value[2]
                const header = `<div>
                                  <div style="width: 499px;height: 65px;background:url('${mapTipT}') no-repeat;background-size: cover;">
                                     <p style="text-align: center;color: #65CCFF;font-size: 32px;padding-top: 8px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${name}</p>
                                  </div>
                                  <div style="width: 499px;background:url('${mapTipM}') repeat-y;">`
                const footer = `</div><div style="width: 499px;height: 56px;background:url('${mapTipB}') no-repeat;background-size: cover;"></div>
                                </div>`
                let content = ``
                data.forEach((item, index) => {
                  const { title, owner, location, url } = item
                  if (index) {
                    content += `<div style="padding: 20px 15px;">
                                    <p style="width: 100%;height: 3px;background:#00BBFF;"></p>
                                </div> `
                  }
                  content += `<p style="text-align: center;font-size: 36px;color: #65CCFF;padding:30px 20px 10px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${title}</p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height: 40px;">
                                持有人: ${owner}
                              </p>
                              <p style="text-align: left;padding: 12px 40px; font-size: 22px;color: #fff;line-height:40px;width: 440px;white-space: normal;">
                                定位: ${location}
                              </p>
                              <div style="text-align: center;padding: 20px 60px 0;">
                                <img style="width: 100%;" src="${url}" alt="">
                              </div>
`
                })
                return header + content + footer
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          }
        ]
      ]
    },
    // 处理数据2
    setSeries2() {
      this.option.series = [
        ...this.defaultSeries,
        ...[
          {
            name: '电池',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: batteryIcon,
            symbolSize: [40, 50],
            symbolOffset: [0, -20],
            data: this.convertData(this.NBDList),
            tooltip: {
              position(point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0] + 200, '5%']
              },
              formatter(params) {
                function formatePDA(str) {
                  const len = 6 - `${str}`.length
                  const arr = new Array(len).fill('0')
                  const tempStr = arr.join('')
                  return `${tempStr}${str}`
                }

                const paramsData = params.data
                const { name, value } = paramsData
                const data = value[2]
                const header = `<div>
                                  <div style="width: 550px;height: 65px;background:url('${mapTipT}') no-repeat;background-size: cover;">
                                     <p style="text-align: center;color: #65CCFF;font-size: 32px;padding-top: 8px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${name}</p>
                                  </div>
                                  <div style="width: 550px;background:url('${mapTipM}') repeat-y;background-size: contain;">`
                const footer = `</div><div style="width: 550px;height: 56px;background:url('${mapTipB}') no-repeat;background-size: cover;"></div>
                                </div>`
                let content = ``
                data.forEach((item, index) => {
                  const { title, totalWeight, totalPower, url } = item
                  const totalWeightTemp = formatePDA(totalWeight)
                  const totalPowerTemp = formatePDA(totalPower)
                  if (index) {
                    content += `<div style="padding: 16px 15px;">
                                    <p style="width: 100%;height: 3px;background:#00BBFF;"></p>
                                </div> `
                  }
                  content += `<p style="text-align: center;font-size: 36px;color: #65CCFF;padding:28px 20px 10px;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;width: 100%;">${title}</p>
                              <div style="text-align: center;padding: 16px 0; ">
                                <span style="display:inline-block;vertical-align:top;color: #00A8FF;font-size: 24px;padding-right: 6px;padding-top: 10px;">回收总电量:</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(0, 1)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(1, 2)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(2, 3)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(3, 4)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(4, 5)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalPowerTemp.substring(5, 6)}</span>
                                <span style="display: inline-block;width:40px;font-size: 28px;color: #00A8FF;font-weight: bold;">kWh</span>
                              </div>
                              <div style="text-align: center;padding: 16px 0; ">
                                <span style="display:inline-block;vertical-align:top;color: #00A8FF;font-size: 24px;padding-right: 6px;padding-top: 10px;">总重量标数:</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(0, 1)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(1, 2)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(2, 3)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(3, 4)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(4, 5)}</span>
                                <span style="display: inline-block;width: 40px;height: 37px;line-height: 37px;background:url('${mapNum}') no-repeat;background-size: 100% 100%;text-align: center;font-size: 30px;padding-right: 6px;color: #00A8FF;font-weight: bold;">${totalWeightTemp.substring(5, 6)}</span>
                                <span style="display: inline-block;width:40px;font-size: 28px;color: #00A8FF;font-weight: bold;">KG</span>
                              </div>
                              <div style="text-align: center;padding-top: 20px;">
                                <img style="width: 450px;height: 260px;" src="${url}" alt="">
                              </div>
`
                })
                return header + content + footer
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          }
        ]
      ]
    },
    // 处理数据1
    setSeries1() {
      this.option.series = [
        ...this.defaultSeries,
        ...[
          {
            name: '红旗',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbolSize: [40, 45],
            symbolOffset: [40, 0],
            symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAA8CAYAAADPAlLCAAAAAXNSR0IArs4c6QAABApJREFUaEPtWj3PDUEYPde30BASIggqlUajV2oUSpVK5SOio6AkPjqFSquRaP0AiU6hQxAiITTimyvPZs46++zM7jvrHW/CvMnmvXdnd55z9jkzN9lzZkj8zYFZamwpzs+AeapuB6gDrmOeUCmCHqh+bz97Qi0YIcBz9p+HPQT9XLoZBpig+Vm/Gxgl1XyLAbdzywS8J1SCSAy4nfsZSHUIkUgDPpDQJ2/g/aHjJeWkQA28P9rxFAkFvhwADz1fUlYEqMB/AOCh5+ctCdcFA0vgKwDwsHOliaQIfAfAQ8k01xuRmZDwBFYCeFtC+BPm3ATgWyDTIeJJaAeMwCoArycULHHLFgBfI0Q6naBUTD5GwI7VAF6WQDRhzm0AvgQS7EizPrQTlBJJWBeMxIsJBUvcsj2Q8N3okeAiZheMxLMSiCbMuTOQYDe40JMk2IU1AJ5OKFjill0APks3oiS4qLmgrQtG4kkJRBPm3O1I2LpodildEzESawE8nlCwxC17AHxy66KSKPGkx+asnahrYkwjGeNVTlVOGXIZu7TKqcppTCMZ41VOVU4Zchm7tMqpymlMIxnjVU5VThlyGbu0yqnKaUwjGeNVTv+9nOzd6dUgmdPhLXuGgjqXLomcHgE4Ky+k7YXwJQB7J7L4qyTM+LgJ4Fpwdmjpmllpb9tPATgW/L8cPpNJ5L4VfwXgDID74nYqCb60PgDgMoCtGSwmvRW3p5bjT9wFcB7AO2cOxkiYmbMRwEUAhxZIhP6EOUV0i5Jvxa2AEaDRMuYUfQBwDsAdMQXNALECTAEYTqYTrBvqSB0GcAHA+hEydIpIgjU6/oR5djo5STwfmPwBANt17Bqage3kAyQ8EQN4BcD+gVo7Ip6d1Ro0HukYxdxTu9kW7g1xNNUwV9dfcamZr0Y/PcLjAE6Eh+n5mHtKGamfHSXBp0Qb2PvY9uN3EsDDoH3fASNgUvLJGM2FMJ3gO2LE9oXfFtuN9M98bKvVM+S9BRxLFLyRmW6FxfhRdp/WO3NBEo36cAoS8fkRjV4YsXVhnR2V2psTiYJOJ3ThaTDlfYhG2NO/JzrX0AgXMWVktZtdiQGSSJYqFYSx2sRyMMjWIhEb5MENxiKUCIvcDjplR5g9omw6qRcP3gs7kqvyZPidUSTrwHUAR6TTuvP1AirabhJiaIt4NEBFAtEgVWqnSQTEFHyqJrfsToCrWROh9z6QpYQUjwImoWaKoaBhjJCke2w4lXDjrbHk2e+8k5Dgj5KP0sVIUPcd7S/w17e9LNIVj0EV4KN17ZobCjJyQp2o9zm3AwPrxNfTiF4vldkLMgqyVHS0l0n9U/AjZHRbbnc7OdnBkwwk+nDvYoMek15O/VKpyjGMizr+T5D4BWmgiVvlhb2MAAAAAElFTkSuQmCC',
            data: this.convertData(this.hqData),
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter(params) {
                  const { value } = params
                  return value[2]
                },
                position: 'inside',
                textStyle: {
                  fontSize: 12,
                  fontWeight: 'bolder',
                  color: '#ffffff'
                },
                show: true
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          },
          {
            name: '奔腾',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbolSize: [40, 45],
            symbolOffset: [80, 0],
            symbol: 'image://data:image/png;base64,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',
            data: this.convertData(this.btData),
            label: {
              normal: {
                formatter(params) {
                  const { value } = params
                  return value[2]
                },
                position: 'inside',
                textStyle: {
                  fontSize: 12,
                  fontWeight: 'bolder',
                  color: '#ffffff'
                },
                show: true
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            },
            zlevel: 2
          }
        ]
      ]
    },
    // 处理数据
    convertData(data) {
      const res = []
      for (let i = 0; i < data.length; i++) {
        let geoCoord = this.geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    },
    // 注册地图
    registerMap() {
      const arr = []
      mapFeatures.features.forEach((item) => {
        this.geoCoordMap[item.properties.name] = item.properties.cp
        arr.push({
          name: item.properties.name
        })
      })
      this.data = arr
      this.$echarts.registerMap(mapName, mapFeatures)
    },
    sumArr(baseArr) {
      const setArr = []
      let currNum = 0
      baseArr.forEach((item, index) => {
        if (index === 0) {
          setArr.push(baseArr[index])
        } else {
          if (currNum) {
            currNum = baseArr[index] + currNum
          } else {
            currNum = baseArr[index] + baseArr[index - 1]
          }
          setArr.push(currNum)
        }
      })
      return setArr
    },
    isArrIndex(arr, num) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] > num) {
          return i
        }
      }
    },
    sum(arr) {
      let total = 0
      arr.forEach((item) => {
        total += item
      })
      return total
    },
    // 获取数据
    getMapData() {
      getMapData().then(({ result }) => {
        const { map1, map2, map3, map4, map5 } = result
        const { hongqi, benteng } = map1
        this.hqData = hongqi
        this.btData = benteng

        // nbd 列表
        map2.data.length && map2.data.forEach((item) => {
          item.value = [item.value]
        })
        this.NBDList = map2.data

        // pda 列表
        map3.data.length && map3.data.forEach((item) => {
          item.value = [item.value]
        })
        this.PDAList = map3.data

        // 便携检测设备
        map4.data.length && map4.data.forEach((item) => {
          item.value = [item.value]
        })
        this.convenienceList = map4.data

        // 客户
        map5.data.length && map5.data.forEach((item) => {
          item.value = [item.value]
        })
        this.clientList = map5.data
        const tempTotalTimerList = [firstMap, this.NBDList.length * mapStep, this.PDAList.length * mapStep, this.convenienceList.length * mapStep, this.clientList.length * mapStep]
        this.totalTimerList = this.sumArr(tempTotalTimerList)
        this.totalTimerCount = this.sum(tempTotalTimerList)
        this.$nextTick(() => {
          this.init()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.index3 {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: url('../assets/images/bg1.png') no-repeat;
  background-size: cover;

  .logout {
    position: absolute;
    right: 20px;
    top: 40px;

    &:hover {
      cursor: pointer;
    }

    img {
      height: 100px;
    }
  }

  .index3-header-title {
    margin-top: 90px;
  }

  .index3-content {
    position: relative;
    flex: 1;
    padding: 27px 64px;
    box-sizing: border-box;

    .index3-content-l {
      position: absolute;
      left: 90px;
      top: 110px;
    }

    .index3-content-r {
      position: absolute;
      right: 90px;
      top: 110px;
    }
  }
}
</style>
